import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export type CheckoutOrigin = 'TABLESIDE' | 'TABLESIDE_QR_TABLE';

interface State {
  card?: core.PaymentCard;
  date?: string;
  options?: core.IOptionOrder[];
  originalOptions?: core.IOptionOrder[];
  purchaseVerifyToken?: string;
  size?: number;
  ticketTypeId?: number;
  ticketTypePackageId?: number;
  time?: string;
  transferPurchaseToken?: string;
  visitEditToken?: string;
  visitEditPaymentMode?: boolean;
  basePurchaseId?: number;
  checkoutFlowOrigin?: CheckoutOrigin;
  requestedTableId?: string;
}

const initialState: State = {};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.SELECTION_UPDATE: {
      return {
        ...state,
        ...(payload || {}),
        options: payload?.options ? [...payload.options] : state.options,
      };
    }
    case AppConstants.SELECTION_SET: {
      return {
        ...(payload || {}),
        options: payload?.options ? [...payload.options] : undefined,
      };
    }
    default:
      return state;
  }
}
